import { call, put } from 'redux-saga/effects';
import DeleteLeaveActions from '../redux/DeleteLeaveRedux';
import { api } from './api';


export function* deleteleavesagas(action: any): Generator<any, void, any> {
  const { leave_id } = action;
  const response = yield call(api.deleteLeave, leave_id);

  // success?
  if (response.ok) {
    // You might need to change the response here - do this with a 'transform',
    // located in ../Transforms/. Otherwise, just pass the data back from the api.
    yield put(DeleteLeaveActions.deleteLeaveSuccess(response.data));
  } else {
    yield put(DeleteLeaveActions.deleteLeaveFailure());
  }
}